module.exports = __webpack_public_path__ + "img/free-trial.e6e36287.jpg";